/* eslint-disable max-len */
import React from 'react';

const FacebookIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" {...props}>
    <path
      fillRule="evenodd"
      d="M17 9.5C17 5.358 13.642 2 9.5 2 5.358 2 2 5.358 2 9.5c0 3.743 2.743 6.846 6.328 7.409v-5.241H6.424V9.5h1.904V7.848c0-1.88 1.12-2.918 2.833-2.918.82 0 1.679.146 1.679.146v1.846h-.946c-.932 0-1.222.578-1.222 1.171V9.5h2.08l-.333 2.168h-1.747v5.24C14.257 16.347 17 13.244 17 9.5"
    />
  </svg>
);

export default FacebookIcon;
